import { Badge } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";

const tones = {
  published: { label: "administration.situationCard.live", variant: "success" },
  concept: { label: "administration.situationCard.concept", variant: "secondary" },
  review: { label: "administration.situationCard.review", variant: "warning" },
  processing: { label: "administration.situationCard.processing", variant: "info" },
} as const;

export function SituationStatus({ status }: { status: keyof typeof tones }) {
  const { t } = useTranslation();
  const tone = tones[status];
  return <Badge variant={tone.variant}>{t(tone.label)}</Badge>;
}
